module.exports = "/images/gotham-12.jpg";